<template>
    <div class="row">

        <modal
            v-show="modal"
            @close="closeModal"
            class="center-modal-content"
          >
            <h3 slot="header" class="header-modal">
                Warning: Delete my account and all associated data
                <i @click="closeModal" class="fas fa-window-close ic" title="close"></i>
            </h3>

            <div slot="body">
                <div class="row bloque">
                    Please type DELETE to confirm deletion of your account and all associated data include data you uploaded.
                </div>
                <div class="field">
                    <input type="text" v-model="input" placeholder="type DELETE" class="input-form">
                    <label for="full_name">delete</label>
                </div>
            </div>

            <div slot="footer">
                <div class="row">
                    <div class="col-xl-12 col-xs-12 full">
                        <div>
                          <button @click="deleteAcct" v-if="input === 'DELETE'" class="btn btn-large bold">
                              Confirm delete
                          </button>
                          <button v-if="input !== 'DELETE'" class="btn btn-large bold" style="cursor: not-allowed" disabled>
                              Confirm delete
                          </button>
                        </div>
                    </div>
                </div>
            </div>

        </modal>

        <div class="col-lg-8 col-lg-offset-2 col-xs-12 content">
            <CreditInfo />
        </div>

        <div class="col-lg-2 col-lg-offset-2 col-xs-12 block content">
            <UserMenu />
        </div>

        <div class="col-lg-6 col-xs-12 block content">
            <div class="setting">
                <h2>Profile settings</h2>
                <div class="content-left">
                    <h4> Update your information </h4>
                </div>
                <div class="row">
                    <div class="col-xl-12 col-xs-12">
                        <div class="row info-form">
                            <form id="email-form" @submit.prevent="update" name="email-form" data-name="Email Form">

                                <div class="col-xl-12 col-xs-12">
                                    <div class="field">
                                        <input type="text" v-model="form.full_name" placeholder="full name" class="input-form" required>
                                        <label for="full_name">Full name</label>
                                    </div>
                                </div>
                                <div class="col-xl-12 col-xs-12">
                                    <div class="field">
                                        <input type="email" v-if="firebase" v-model="form.email" :title="title" placeholder="email" class="input-form" readonly>
                                        <input type="email" v-if="!firebase" v-model="form.email" placeholder="email" class="input-form" required>
                                        <label for="email">Email</label>
                                    </div>
                                </div>
                                <div class="col-xl-12 col-xs-12">
                                    <flash-message class="large"></flash-message>
                                    <input type="submit" value="Update information" class="btn large-btn bold" v-if="!disable">
                                    <input type="submit" value="Updating..." class="btn large-btn bold" v-if="disable" disabled>
                                </div>
                            </form>
                            <div class="col-xl-12 col-xs-12">
                                <div class="delete" @click="modal = true"> Delete my account </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import CreditInfo from '@/components/CreditInfo.vue'
import UserMenu from '@/components/UserMenu.vue'
import modal from '@/components/Modal.vue'
import { mapMutations } from 'vuex'

export default {
  name: 'account',
  components: {
    CreditInfo,
    UserMenu,
    modal
  },
  mounted () {
    this.messageStorage.destroyAll()
  },
  data () {
    return {
      disable: false,
      title: 'you can not edit your email because you are login with Google',
      firebase: this.$store.state.user.data.firebase,
      form: {
        full_name: this.$store.state.user.data.full_name,
        email: this.$store.state.user.data.email
      },
      messageStorage: this.flash(),
      modal: false,
      input: ''
    }
  },
  methods: {
    ...mapMutations('user', [
      'logOut',
      'changeLoaderState',
      'setAuthUser'
    ]),
    ...mapMutations([
      'user/setAuthUser',
      'uploadedLeadList/setFileData',
      'uploadedLeadList/clearData'
    ]),
    closeModal () {
      this.modal = false
    },
    Logout () {
      Vue.http.headers.common['Authorization'] = 'Bearer '
      this.logOut()
      this['uploadedLeadList/setFileData']({ file: false, state: 'default', credits: 0, text: '' })
      this['uploadedLeadList/clearData']()
      this.$router.push({ name: 'login' })
      // this.$router.go()
    },
    deleteAcct () {
      this.input = 'Deleting your account...'
      this.$http.delete('/api/user/delete', { body: { input: 'DELETE' } }).then((res) => {
        console.log(res)
        this.input = ''
        this.closeModal()
        this.Logout()
      }).catch((err) => {
        this.input = ''
      })
    },
    update: function () {
      this.disable = true
      this.messageStorage.destroyAll()
      if (this.form.full_name && this.form.email) {
        this.$http.post('/api/user/update_info', this.form).then((res) => {
          this['user/setAuthUser'](res.data)
          this.messageStorage.flash('Your profile has been updated', 'success')
          this.disable = false
        }).catch((err) => {
          this.messageStorage.flash(err.data.error, 'error')
          this.disable = false
        })
      }
    }
  }
}
</script>

<style lang="scss">

.delete {
    width: 98%;
    margin-bottom: 30px;
    color: red;
    text-align: center;
    cursor: pointer;
}

.large-btn {
    width: 98%;
    margin-bottom: 30px;
}

.large {
    width: 98%;
}

.info-form {
    margin: auto;
    width: 100%;
    text-align: left;
    justify-content: center;
}

.content-left {
    float: left;
}

.ico {
    margin-right: 10px;
}

.setting {
    text-align: center;
    justify-content: center;
    margin: auto;
    margin-top: 50px;
    margin-left: 20px;
    height: 100%;
}

.content {
    margin-top: 30px;
    margin-right: 1px;
}

.credit {
    margin-top: 20px;
}

@media only screen and (min-width : 481px) {
    .row {
        display: flex;
        flex-wrap: wrap;
    }
}

</style>
